import { render, staticRenderFns } from "./QuotaSummary.vue?vue&type=template&id=323146f5&scoped=true&"
import script from "./QuotaSummary.vue?vue&type=script&lang=js&"
export * from "./QuotaSummary.vue?vue&type=script&lang=js&"
import style0 from "./QuotaSummary.vue?vue&type=style&index=0&id=323146f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323146f5",
  null
  
)

export default component.exports